export default "/assets/images/carbon-monoxide-video.c483fa870b8c47fb.mp4";